import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CHECKOUT_URL } from '../data/content';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const anchor = document.getElementById('hero-cta-end');
    if (!anchor) return;
    const observer = new IntersectionObserver(([entry]) => {
      setVisible(entry.boundingClientRect.top < 0);
    }, {
      threshold: 0,
      rootMargin: '0px'
    });
    observer.observe(anchor);
    return () => observer.disconnect();
  }, []);
  return <AnimatePresence data-id="element-33" data-mp="2fuehcv8zn06y">
      {visible ? <motion.div initial={{
      y: 90,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 90,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-6 sm:px-6 sm:pb-5" style={{
      background: 'linear-gradient(to top, rgba(28,19,48,0.28), rgba(28,19,48,0))'
    }} data-id="element-34" data-mp="2ftd18cd47nid">
          <a href={CHECKOUT_URL} className="mp-shake mx-auto flex w-full max-w-md items-center justify-center gap-2 rounded-2xl bg-teal px-5 py-4 text-center text-[15px] font-extrabold uppercase tracking-[0.02em] text-white shadow-[0_12px_28px_rgba(14,140,140,0.45)] transition-colors duration-200 ease-out hover:bg-teal-light focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-white sm:text-base" data-id="element-35" data-mp="333jej8cbwi4d">
            Ottieni il progetto per 19 €
          </a>
        </motion.div> : null}
    </AnimatePresence>;
}